<template>
  <div class="mark_wrap" ref="popRef" v-html="html"></div>
</template>

<script>
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

export default {
  name: "MarkRender",
  props: {
    // 输入的 markdown 文本
    text: {
      type: String,
      default: "",
    },
    // 是否需要显示光标？比如在消息流结束后是不需要显示光标的
    showCursor: {
      type: Boolean,
      default: false,
    },
    abortStream: {
      type: Boolean,
      default: false,
    },
    redenId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // html: "",
    };
  },
  watch: {
    text: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.showCursor) {
            const parent = this.$refs.popRef;
            if (!parent) return;

            let lastChild = parent.lastElementChild || parent;

            // 兼容是ul标签的情况，找到OL标签内部的最后一个元素
            if (lastChild.tagName === "OL" || lastChild.tagName === "UL") {
              lastChild = this.findLastElement(lastChild);
            }
            lastChild.insertAdjacentHTML(
              "beforeend",
              '<span class="cursor"></span>'
            );
          }
        });
      },
    },
    abortStream(nv) {
      if (nv) {
        const cursor = document.querySelectorAll(`.cursor`)[0];
        cursor && cursor.parentNode.removeChild(cursor);
      }
    },
    showCursor(nv) {
      if (!nv) {
        const cursor = document.querySelectorAll(`.cursor`)[0];
        cursor && cursor.parentNode.removeChild(cursor);
      }
    },
  },
  computed: {
    html() {
      const config = {
        ALLOWED_ATTR: [],
      };

      let s = this.mdi()
        .render(this.text)
        .replace(/<a /g, '<a target="_blank" ');
      return DOMPurify.sanitize(s, config);
    },
  },
  mounted() {
    // this.init();
  },
  methods: {
    mdi() {
      return new MarkdownIt({
        linkify: true,
        breaks: true,
        highlight() {
          return "";
        },
      });
    },
    findLastElement(element) {
      // 如果该DOM没有子元素，则返回自身
      if (!element.children.length) {
        return element;
      }

      const childs = this.cleanWhiteSpaceNode(element).childNodes;
      const lastNode = childs[childs.length - 1];

      if (lastNode.nodeType == Node.ELEMENT_NODE) {
        return this.findLastElement(lastNode);
      }

      return element;
    },
    cleanWhiteSpaceNode(parent) {
      let oldNodes = parent.childNodes;

      for (let n = 0; n < oldNodes.length; n++) {
        if (oldNodes[n].nodeType === 3 && /^\s+$/.test(oldNodes[n].nodeValue)) {
          parent.removeChild(oldNodes[n]);
        }
      }

      return parent;
    },
  },
};
</script>

<style scoped lang="less">
.mark_wrap {
  /deep/ ol {
    list-style-type: decimal;
    padding: 5px 0 5px 16px;

    li {
      padding: 5px 0;
    }
  }
  /deep/ ul {
    list-style-type: disc;
    padding: 5px 0 5px 16px;

    li {
      padding: 5px 0;
    }
  }

  /deep/ .cursor {
    display: inline-block;
    content: "";
    width: 2px;
    height: 16px;
    background-color: #0a6cff;
    animation: blink 1.2s step-end infinite;
    margin-left: 2px;
    vertical-align: sub;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
